import { simulationUniforms } from "./uniforms";
import { app } from "./context";

/**
 * Map pointer position to simulation UV (0–1), same space as fragment v_uv.
 * Must use the canvas's on-screen size (CSS/layout), not the WebGL buffer
 * dimensions — those differ when canvas.scale ≠ 1.
 */
function clientToSimulationUV(canvas, clientX, clientY) {
  const rect = canvas.getBoundingClientRect();
  const x = (clientX - rect.left) / rect.width;
  const y = 1 - (clientY - rect.top) / rect.height;
  return { x, y };
}

export function setupMouse() {
  const { canvas } = app;
  let mouseDown = false;

  const mouseFollower = document.createElement("div");
  mouseFollower.classList.add("mouse-follower");
  mouseFollower.style.width = simulationUniforms.brushRadius.value * 2 + "px";
  mouseFollower.style.height = simulationUniforms.brushRadius.value * 2 + "px";
  mouseFollower.style.position = "absolute";
  mouseFollower.style.border = "1px solid white";
  mouseFollower.style.borderRadius = "1000px";
  mouseFollower.style.pointerEvents = "none";
  document.body.append(mouseFollower);

  canvas.addEventListener("mousedown", (e) => {
    mouseDown = true;
    mouseFollower.style.backgroundColor = "rgba(255,255,255,.2)";
    const uv = clientToSimulationUV(canvas, e.clientX, e.clientY);
    simulationUniforms.mousePosition.value.x = uv.x;
    simulationUniforms.mousePosition.value.y = uv.y;
  });

  canvas.addEventListener("mouseup", () => {
    mouseDown = false;
    mouseFollower.style.backgroundColor = "rgba(255,255,255,0)";
  });

  canvas.addEventListener("mousemove", (e) => {
    if (mouseDown) {
      const uv = clientToSimulationUV(canvas, e.clientX, e.clientY);
      simulationUniforms.mousePosition.value.x = uv.x;
      simulationUniforms.mousePosition.value.y = uv.y;
    } else {
      simulationUniforms.mousePosition.value.x = -1;
      simulationUniforms.mousePosition.value.y = -1;
    }
  });

  window.addEventListener("wheel", (e) => {
    const wheelStep = e.deltaY / 100;
    const r = simulationUniforms.brushRadius.value;
    if (r + wheelStep > 5 && r + wheelStep < 100) {
      simulationUniforms.brushRadius.value += wheelStep;
      mouseFollower.style.width =
        simulationUniforms.brushRadius.value * 2 + "px";
      mouseFollower.style.height =
        simulationUniforms.brushRadius.value * 2 + "px";
      mouseFollower.style.top =
        e.clientY - simulationUniforms.brushRadius.value + "px";
      mouseFollower.style.left =
        e.clientX - simulationUniforms.brushRadius.value + "px";
    }
  });

  window.addEventListener("mousemove", (e) => {
    const newX = e.clientX;
    const newY = e.clientY;
    const rect = canvas.getBoundingClientRect();
    const leftSide = rect.left;
    const rightSide = rect.right;
    const topSide = rect.top;
    const bottomSide = rect.bottom;

    if (
      newX > leftSide &&
      newX < rightSide &&
      newY > topSide &&
      newY < bottomSide
    ) {
      mouseFollower.style.display = "block";
      mouseFollower.style.top =
        e.clientY - simulationUniforms.brushRadius.value + "px";
      mouseFollower.style.left =
        e.clientX - simulationUniforms.brushRadius.value + "px";
    } else {
      mouseFollower.style.display = "none";
    }
  });
}
